import React, { useRef, useState, forwardRef } from "react";
import classes from "../../Assets/Styles/Demo.module.css";

const TextInputArea = forwardRef(({
    inputText,
    setInputText,
    isLoading,
    onGenerateAudio,
    useNewMethod,
}, externalRef) => {
    const internalRef = useRef(null);
    const textAreaRef = externalRef || internalRef;

    const [cursorPosition, setCursorPosition] = useState(0);

    const handleTextChange = (e) => {
        setInputText(e.target.value);
    };

    const handleSelectionChange = () => {
        if (textAreaRef.current) {
            setCursorPosition(textAreaRef.current.selectionStart);
        }
    };

    const insertEmojiAtCursor = (emoji) => {
        if (textAreaRef.current) {
            // Get the current cursor position
            const currentPosition = cursorPosition;
            // Split the current text into two parts at the cursor position
            const textBefore = inputText.substring(0, currentPosition);
            const textAfter = inputText.substring(currentPosition);
            // Insert the emoji between the two parts
            const newText = textBefore + emoji + textAfter;
            // Update the text state
            setInputText(newText);
            // Calculate the new cursor position (after the inserted emoji)
            const newPosition = currentPosition + emoji.length;
            // Focus the textarea and update the selection range after render
            setTimeout(() => {
                if (textAreaRef.current) {
                    textAreaRef.current.focus();
                    textAreaRef.current.setSelectionRange(newPosition, newPosition);
                    setCursorPosition(newPosition);
                }
            }, 0);
        }
    };

    return (
        <div className={classes["bubbleContainer"]}>
            <button
                className={classes["ttsButton"]}
                onClick={onGenerateAudio}
                disabled={isLoading}
            >
                {isLoading ? "⏳" : "🗣️"}
            </button>

            {!useNewMethod && (
                <>
                    <button
                        className={classes["breathButton"]}
                        onClick={() => insertEmojiAtCursor("💨")}
                        disabled={isLoading}
                    >
                        💨
                    </button>
                    <button
                        className={classes["laughButton"]}
                        onClick={() => insertEmojiAtCursor("😂")}
                        disabled={isLoading}
                    >
                        😂
                    </button>
                </>
            )}

            <textarea
                ref={textAreaRef}
                className={`${classes["bubbleInput"]} ${isLoading ? classes["bubbleInput-disabled"] : ""}`}
                value={inputText}
                onChange={handleTextChange}
                onSelect={handleSelectionChange}
                onKeyUp={handleSelectionChange}
                onMouseUp={handleSelectionChange}
                onClick={handleSelectionChange}
                placeholder="Type your text here..."
                readOnly={isLoading}
            />
        </div>
    );
});

export default TextInputArea;
